
function TopHeader(props: { clientLogo: string | undefined; companyName: string | undefined; }) {

  return (
    <div className="TopHeader">
      <img src={props.clientLogo} alt={props.companyName} />
    </div>
  );
}

export default TopHeader;
